
export const handleGeminiTranscription = (onRecordingStop) => {
    return new Promise(async (resolve, reject) => {
        // Check if browser supports mediaDevices
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            console.error("Media Devices API not supported.");
            reject("Microphone access is not supported in this browser or context (requires HTTPS or localhost).");
            return;
        }

        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            const mediaRecorder = new MediaRecorder(stream);
            const audioChunks = [];

            mediaRecorder.ondataavailable = (event) => {
                audioChunks.push(event.data);
            };

            mediaRecorder.onstop = async () => {
                if (onRecordingStop) onRecordingStop();
                const audioBlob = new Blob(audioChunks, { type: 'audio/webm' });
                const formData = new FormData();
                formData.append('audio', audioBlob, 'recording.webm');

                try {
                    // Using localhost for development
                    const response = await fetch('https://flask.brlps.in/transcribe', {
                        method: 'POST',
                        body: formData,
                    });

                    if (!response.ok) {
                        throw new Error('Transcription failed');
                    }

                    const data = await response.json();
                    resolve(data.transcript);
                } catch (error) {
                    console.error('Transcription error:', error);
                    reject(error.message);
                } finally {
                    // Stop all audio tracks to release the microphone
                    stream.getTracks().forEach(track => track.stop());
                }
            };

            // Record for 4 seconds (or you can implement a stop button)
            // For now, let's make it fixed duration for simplicity, 
            // or better, we can return the recorder to the component to control.
            // But let's follow the previous pattern of a single promise.
            mediaRecorder.start();
            setTimeout(() => {
                if (mediaRecorder.state === 'recording') {
                    mediaRecorder.stop();
                }
            }, 4000); // 4 seconds recording

        } catch (error) {
            console.error('Microphone access error:', error);
            reject('Microphone access denied or not available.');
        }
    });
};
